
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { BookOpen } from 'lucide-react';
import { AdminQualification } from '@/types/admin.types';

interface AdminQualificationsTabProps {
  qualifications: AdminQualification[];
}

const AdminQualificationsTab = ({ qualifications }: AdminQualificationsTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Qualifications</CardTitle>
        <CardDescription>
          Professional qualifications and certifications
        </CardDescription>
      </CardHeader>
      <CardContent>
        {qualifications.length === 0 ? (
          <div className="text-center py-6 text-muted-foreground">
            <BookOpen className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p>No qualifications recorded</p>
          </div>
        ) : (
          <div className="space-y-4">
            {qualifications.map((qual, index) => (
              <div key={qual.id} className="bg-muted/40 p-4 rounded-md">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="font-semibold">{qual.degree}</h3>
                    <p className="text-sm text-muted-foreground">{qual.field}</p>
                  </div>
                  <Badge variant="outline">{qual.year}</Badge>
                </div>
                <p className="text-sm mt-1">{qual.institution}</p>
                {index < qualifications.length - 1 && <Separator className="mt-4" />}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminQualificationsTab;
